import { type ReactNode, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ResponsiveTabs from '@/primitives/responsive.tabs';

export interface TabNavItem {
  label: string;
  key: string;
  richLabel?: ReactNode;
}

export interface TabContent {
  [key: string]: () => ReactNode;
}

export interface TabsNavProps {
  tabs: TabNavItem[];
  content: TabContent;
}

const TabsNav = ({ tabs, content }: TabsNavProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const currentTab = useMemo(() => tabs.find(x => x.key === tab) ?? tabs[0], [tab]);
  const options = useMemo(() => tabs.map(x => ({ key: x.key, title: x.label })), [tabs]);

  const setCurrentTab = (key: string) => {
    setSearchParams(prev => {
      prev.set('tab', key);
      return prev;
    });
  };

  return (
    <div>
      <ResponsiveTabs
        forceHorizontal
        options={options}
        tab={currentTab?.key}
        setTab={setCurrentTab}
      />
      <div className='mt-4'>{content[currentTab?.key]?.() ?? null}</div>
    </div>
  );
};

export default TabsNav;
